import { GlobalUtils } from "src/app/shared/global-utils";

export class FormDataCreateTrainings {
  public async build(element: any): Promise<FormData> {
    let {
      trainingName,
      type,
      partners,
      systemId,
      fileType,
      systemVersion,
      fileDescription,
      fileAttachment,
      createdAt,
    } = element;

    let formData = new FormData();

    if (typeof fileAttachment === 'string' && fileAttachment.toLowerCase().includes(';base64')) {
      // Obtém o tipo MIME e a extensão do arquivo a partir da string Base64
      const mimeType = fileAttachment.substring(
        fileAttachment.indexOf(':') + 1,
        fileAttachment.indexOf(';')
      );
      const extension = mimeType.split('/')[1] || 'bin'; 

      const base64Data = fileAttachment.split(',')[1];
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });

      // Adiciona o arquivo ao FormData com a extensão correta
      formData.append('fileAttachment', new File([blob], `filename.${extension}`));
    } else if (fileAttachment instanceof File) {
      formData.append('fileAttachment', fileAttachment, fileAttachment.name);
    }

    if (systemId) {
      formData.append('systemId', systemId);
    } else {
      throw new Error('O campo "systemId" é obrigatório e não foi definido.');
    }

    formData.append('createdAt', createdAt ? new Date(createdAt).toISOString() : new Date().toISOString());
    formData.append('type', type);

    if (partners) {
      formData.append('partners', partners);
    }
    formData.append('systemVersion', systemVersion);
    formData.append('fileType', fileType);
    formData.append('fileDescription', fileDescription);
    formData.append('trainingName', trainingName);

    return formData;
  }
}